var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllSignaturesComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5H21.4648C22.1277 5.0001 22.7633 5.26341 23.232 5.73203L34.268 16.768C34.7366 17.2367 34.9999 17.8723 35 18.5352V33.75C35 34.7446 34.6049 35.6984 33.9017 36.4017C33.1984 37.1049 32.2446 37.5 31.25 37.5H15C14.0054 37.5 13.0516 37.1049 12.3483 36.4017C11.6451 35.6984 11.25 34.7446 11.25 33.75V23.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.56 21C18.9429 21 16 23.9429 16 27.56C16 31.1771 18.9429 34.12 22.56 34.12C26.1771 34.12 29.12 31.1771 29.12 27.56C29.12 23.9429 26.1771 21 22.56 21ZM25.974 25.3615L21.7353 30.4076C21.6888 30.463 21.6309 30.5077 21.5656 30.5388C21.5003 30.5699 21.4291 30.5865 21.3568 30.5877H21.3483C21.2776 30.5877 21.2076 30.5728 21.143 30.544C21.0784 30.5152 21.0206 30.4731 20.9733 30.4205L19.1567 28.4021C19.1105 28.3531 19.0747 28.2955 19.0511 28.2325C19.0276 28.1695 19.0169 28.1024 19.0197 28.0352C19.0224 27.968 19.0386 27.9021 19.0672 27.8412C19.0958 27.7803 19.1363 27.7258 19.1863 27.6808C19.2363 27.6358 19.2948 27.6013 19.3583 27.5792C19.4218 27.5572 19.4891 27.548 19.5562 27.5523C19.6233 27.5567 19.6889 27.5743 19.7491 27.6044C19.8093 27.6344 19.8629 27.6761 19.9067 27.7272L21.335 29.3142L25.2013 24.7124C25.2881 24.6121 25.4108 24.55 25.5429 24.5395C25.6751 24.529 25.8061 24.5708 25.9076 24.6561C26.0091 24.7414 26.073 24.8632 26.0854 24.9952C26.0978 25.1271 26.0578 25.2587 25.974 25.3615Z",
    fill: "#287A26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.625V15C22.5 15.663 22.7634 16.2989 23.2322 16.7678C23.7011 17.2366 24.337 17.5 25 17.5H34.375",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.25V18.125C12.5033 18.3721 12.457 18.6174 12.3639 18.8464C12.2708 19.0753 12.1328 19.2833 11.9581 19.4581C11.7833 19.6328 11.5753 19.7708 11.3464 19.8639C11.1174 19.957 10.8721 20.0033 10.625 20C9.6875 20 8.75 19.2891 8.75 18.125V6.875C8.75 4.48516 10.0445 2.5 12.5 2.5C14.9555 2.5 16.25 4.4375 16.25 6.82656V17.6664C16.25 21.0258 14.0766 23.75 10.625 23.75C7.17344 23.75 5 21.0266 5 17.6664V11.25",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSignaturesComplete);
export default __webpack_public_path__ + "static/media/all-signatures-complete.525726ec0d74d48b4418a282ad2c0f6f.svg";
export { ForwardRef as ReactComponent };